module.exports = __webpack_public_path__ + "assets/b46.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b46.png
// module id = 634
// module chunks = 0